import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
/* componentes visuales */
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import IpmIcon from '../../images/PEMS_logo.png';


/*Styling */
const styles = theme => ({
  "@global":{
    body:{
      backgroundColor:"#2E343F"
    }
  },
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 21,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    backgroundColor: "white",
    margin:0,
    width:theme.spacing.unit*12,
    height:theme.spacing.unit*12,
    minWidth:80, 
    minHeight:80
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
   myinput: {
     root:{
        '& label.Mui-focused': {
        color: 'green',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'red',
        },
        '&:hover fieldset': {
          borderColor: 'yellow',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'green',
        },
      },
     }
  },
});

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
      '&:hover fieldset': {
        borderColor: 'yellow',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'green',
      },
    },
  },
})(TextField);

let email=""
class ResetPasswordView extends Component {
  
  constructor(props) {
    super(props)
  
    this.state = {
       email:"", 
       errores:{},
       formValid:false
    }
    this.handleChange=this.handleChange.bind(this);
    this.passwordResetRequest=this.passwordResetRequest.bind(this);
  }
  
  handleChange(event) {
    const target = event.target;
    const value = target.value;

    let emailInput =  value;
    email=emailInput
    this.validateForm();
  }
  passwordResetRequest=()=>{
    if(this.state.formValid){
      let emailInput = email.trim();
      this.props.resetPassword(emailInput)
      this.props.setResetPasswordLoading()
      this.setState({
        email:"", 
        errores:{},
        formValid:false
      })
    }
  }
  validateForm = () => {
    let errores = {};
    let formValid = true;
    if (!email || email.trim().length < 1) {
      errores.message = 'Required field';
      formValid = false;
    }
    this.setState({
      errores: errores,
      formValid: formValid,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <main className={classes.main} >
        <div >
            <CssBaseline />
            <Paper className={classes.paper}>
                <Avatar className={classes.avatar} src={IpmIcon} style={{marginBottom:'0%',/* minWidth:80, minHeight:80,*/ borderRadius:0}} variant="square">
                </Avatar>
                <Typography component="h1" variant="h5" style={{color:"#5a6271"}}>
                  Forgot your password?
                </Typography>
              <form className={classes.form}>
                {this.props.resetPasswordLoading===0?
                <FormControl margin="normal" required fullWidth className={classes.myroot}>
                  <CssTextField
                    label="E-mail"
                    variant="outlined"
                    id="email" name="email" autoComplete="email" autoFocus 
                    value={email}
                    placeholder="Enter your E-mail"
                    error={this.state.errores.username ? true : false}
                    onChange={this.handleChange} 
                    disabled={this.props.resetPasswordLoading>0}
                  />
                </FormControl> :""  }            
                <br/>
                <br/>
                <span style={{color:"green", marginLeft:"25px"}}>{this.props.resetPasswordLoading>0?"E-mail has been sent successfully":""}</span>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={this.passwordResetRequest}     
                  disabled={!this.state.formValid || this.props.resetPasswordLoading>0}           
                >
                  Send me password instructions.
                </Button>
              </form>
            </Paper>
          </div>
        </main>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    
  };
}


ResetPasswordView.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ResetPasswordView));


// WEBPACK FOOTER //
// ./src/features/login/ResetPasswordView.js